import { Button } from "@/components/ui/button";
import { CardContent, CardFooter } from "@/components/ui/card";
import { useWebAuthnChallengeFlow } from "@/features/auth/hooks/use-webauthn-challenge";
import { FingerprintIcon } from "@phosphor-icons/react";
import { useEffect } from "react";
import { useTranslation } from "@/features/utils/i18n";

export const WebauthnChallenge = (props: {
  userIdOrEmail?: string; // Optional - for discoverable credentials
  restrictToKeyId?: string; // Restrict to specific key ID
  restrictToKeyName?: string; // Restrict to specific key name (display purposes)
  autoChallenge?: boolean; // Auto-trigger challenge if matching key is found
  onSuccess: (preSignedToken: string) => void;
  onEndChallenge?: () => void; // Called when auto challenge ends (success or failure)
}) => {
  const { t } = useTranslation();
  const { startChallenge, isProcessing, didUseWebauthnOnThisDevice } =
    useWebAuthnChallengeFlow({
      userIdOrEmail:
        props.userIdOrEmail ||
        localStorage.getItem("lastUsedUserId") ||
        undefined,
      restrictToKeyId: props.restrictToKeyId,
      restrictToKeyName: props.restrictToKeyName,
      autoChallenge: props.autoChallenge,
      onSuccess: props.onSuccess,
      onEndChallenge: props.onEndChallenge,
    });

  useEffect(() => {
    console.log("rebuilt WebauthnChallenge");
  }, []);

  return (
    <>
      {didUseWebauthnOnThisDevice && (
        <>
          <CardContent>
            <div className="flex flex-col gap-4">
              <p className="text-sm text-muted-foreground">
                {t("webauthn.prompt")}
              </p>
            </div>
          </CardContent>
          <CardFooter>
            <Button
              type="button"
              className="w-full"
              onClick={startChallenge}
              disabled={isProcessing}
            >
              <FingerprintIcon className="mr-2" />
              {isProcessing
                ? t("webauthn.authenticating")
                : t("webauthn.useSecurityKey")}
            </Button>
          </CardFooter>
        </>
      )}
      {!didUseWebauthnOnThisDevice && (
        <>
          <CardContent>
            <div className="flex flex-col gap-4">
              <p className="text-sm text-muted-foreground">
                {t("webauthn.doYouHaveAKeyYet")}
                <Button
                  type="button"
                  variant={"link"}
                  className="p-0"
                  onClick={startChallenge}
                  disabled={isProcessing}
                >
                  {isProcessing
                    ? t("webauthn.authenticating")
                    : t("webauthn.useSecurityKey")}
                </Button>
              </p>
            </div>
          </CardContent>
        </>
      )}
    </>
  );
};
